import {combineReducers} from 'redux';
import views from './viewReducer';
import data from './dataReducer';

export default combineReducers({
  views,
  data,
});
